export enum UsersStatisticsActionName {
  'writer' = 'f_get_writers_list',
  'factchecker' = 'f_get_factcheckers_list',
  'compiler' = 'f_get_compilers_list',
  manager = 'f_get_writers_list',
}
